import { InputSwitch } from '@repo/atomic-components';
import type { InputSwitchChangeEvent } from '@repo/atomic-components';
import { setSidebarMode, useSidebarMode } from '../../sidebarMode';
import type { SettingControlProps } from '../types';

/** Sidebar pin setting; shares the `sidebarMode` store with the sidebar's pin icon. */
export const SidebarModeControl = ({ labelId }: SettingControlProps) => {
  const mode = useSidebarMode();

  const handleChange = (event: InputSwitchChangeEvent) => setSidebarMode(event.value ? 'fixed' : 'overlay');

  return <InputSwitch checked={mode === 'fixed'} onChange={handleChange} aria-labelledby={labelId} />;
};
